/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Changelog
 */
export interface Changelog {
    /**
     * 
     * @type {string}
     * @memberof Changelog
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Changelog
     */
    commitHash: string;
    /**
     * 
     * @type {string}
     * @memberof Changelog
     */
    changes: string;
    /**
     * 
     * @type {Date}
     * @memberof Changelog
     */
    releasedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Changelog
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Changelog
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the Changelog interface.
 */
export function instanceOfChangelog(value: object): value is Changelog {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('commitHash' in value) || value['commitHash'] === undefined) return false;
    if (!('changes' in value) || value['changes'] === undefined) return false;
    if (!('releasedAt' in value) || value['releasedAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ChangelogFromJSON(json: any): Changelog {
    return ChangelogFromJSONTyped(json, false);
}

export function ChangelogFromJSONTyped(json: any, ignoreDiscriminator: boolean): Changelog {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'commitHash': json['commitHash'],
        'changes': json['changes'],
        'releasedAt': (new Date(json['releasedAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function ChangelogToJSON(json: any): Changelog {
    return ChangelogToJSONTyped(json, false);
}

export function ChangelogToJSONTyped(value?: Changelog | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'commitHash': value['commitHash'],
        'changes': value['changes'],
        'releasedAt': value['releasedAt'].toISOString(),
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

